import React from 'react';
import {connect} from 'react-redux';
import {getCurrentThread} from '../../redux/selectors';
import {RIETextArea} from 'riek';

import styles from './ThreadInfo.module.css';
import {threadNoteUpdate} from '../../redux/actions';

const ThreadNoteEdit = ({thread, changeNote, isLoading}) => (
    <RIETextArea dispabled={isLoading} value={thread.note || ''} change={changeNote} propName="note" className={styles.note}/>
);

export default connect(
    (state) => {
        const thread = getCurrentThread(state);

        return {
            thread,
            isLoading: state.getIn(['threadNoteMeta', 'loading'])
        };
    },
    (dispatch) => ({
        changeNote(e) {
            return dispatch(threadNoteUpdate(e.note));
        }
    })
)(ThreadNoteEdit);
